import { Helper } from '../Helper';
export class ArrSliceHelper extends Helper {
    constructor(options) {
        super();
        this.hasEnd = options.hasEnd === undefined ? false : options.hasEnd;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            if (this.hasEnd) {
                sb.emitOp(node, 'DROP');
            }
            sb.emitOp(node, 'DROP');
            return;
        }
        if (!this.hasEnd) {
            sb.emitOp(node, 'OVER');
            sb.emitOp(node, 'ARRAYSIZE');
            sb.emitOp(node, 'SWAP');
        }
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'LT');
            },
            whenTrue: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitOp(node, 'ADD');
                sb.emitOp(node, 'ROT');
            },
        }));
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'LT');
            },
            whenTrue: () => {
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitOp(node, 'ADD');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'SWAP');
            },
        }));
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'ARRAYSIZE');
        sb.emitOp(node, 'MIN');
        sb.emitOp(node, 'ROT');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'MAX');
        sb.emitOp(node, 'SWAP');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'LT');
            },
            each: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitPushInt(node, 5);
                sb.emitOp(node, 'PICK');
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'PICKITEM');
                sb.emitOp(node, 'APPEND');
                sb.emitOp(node, 'INC');
                sb.emitOp(node, 'ROT');
            },
            cleanup: () => {
            },
        }));
        sb.emitOp(node, 'DROP');
        sb.emitOp(node, 'DROP');
        sb.emitOp(node, 'NIP');
    }
}

//# sourceMappingURL=ArrSliceHelper.js.map
